import axios from "axios";
import { clearTokens } from "@/lib/utils/auth";

// 개발환경에서는 프록시를 통해 요청, 프로덕션에서는 직접 요청
const getBaseURL = () => {
  return (
    process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.primes-cloud.co.kr"
  );
};

const apiClient = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true, // 쿠키 자동 포함
});

apiClient.interceptors.request.use((config) => {
  // 쿠키 기반 인증에서는 Authorization 헤더가 필요 없음
  // 쿠키는 자동으로 포함됨 (withCredentials: true)
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    // 쿠키 기반 인증에서 401 에러 처리
    if (err.response?.status === 401) {
      // 인증 실패시 사용자 정보 삭제하고 로그인 페이지로 이동
      clearTokens();
      window.location.href = "/login";
    }

    return Promise.reject(err);
  },
);

export default apiClient;
